import BaseModel from "./../base/baseModel";

export default class bandeiraXFormaPagamentoModel extends BaseModel {
    id?: number = null;
    formaRecebimentoId?: number = null;
    bandeiraId: number = null;
    bandeiraDescricao: string = null;
}
